import { render, staticRenderFns } from "./SoundCouples.vue?vue&type=template&id=975ea4a6&lang=pug&"
import script from "./SoundCouples.vue?vue&type=script&lang=js&"
export * from "./SoundCouples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports